module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S8 Midnight Black.8f5caab4.png";